class VideoMedia extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
  
    init() {
      if (this.getAttribute('loaded')) return;

      new IntersectionObserver(([entry], observer) => {
        if (!entry.isIntersecting) return;
        
        this.loadContent();
        observer.disconnect();
      }, { threshold: 0.1, once: true }).observe(this);
    }

    loadContent() {
      this.setAttribute('loaded', true);
      this.querySelector('img')?.remove();
  
      // Extract content from <noscript> and parse it
      const templateString = this.querySelector('noscript')?.textContent.trim();
      if (!templateString) return;
  
      const parser = new DOMParser();
      const doc = parser.parseFromString(templateString, 'text/html');
      const video = doc.querySelector('video');
  
      if (video) {
        this.appendChild(video);
        video.play().catch(err => console.warn("Autoplay failed:", err));
      }
    }
}
  
customElements.define('video-media', VideoMedia);


// Hubspot Installers form
document.querySelectorAll('.form-opener').forEach(e=> {
    e.addEventListener('click', function(el) {
        el.preventDefault()

        var parent = e.closest('.tab__content')
        var formWrapper = parent.querySelector('.hubspot-form-wrapper')
        var link = e.href

        formWrapper.removeAttribute('hidden')
        
        if ( formWrapper.querySelector('iframe') == null ) {
            formWrapper.insertAdjacentHTML('afterbegin', `<iframe src="${link}" frameborder="0"></iframe>`)
            formWrapper.scrollIntoView({ behavior: 'smooth', block: 'center',inline: 'center' });
            e.style.display = 'none';
        }
    }) 
})

document.querySelectorAll('.form-opener, .button--quote').forEach(e => {
    e.addEventListener('click', function(el) {
        el.preventDefault()

        var targetId = e.dataset.id
        var formWrapper = document.getElementById(targetId)
        var link = e.href

        if (formWrapper) {
            formWrapper.removeAttribute('hidden')
            
            if (formWrapper.querySelector('iframe') == null) {
                formWrapper.insertAdjacentHTML('afterbegin', `<iframe src="${link}" frameborder="0"></iframe>`)
                formWrapper.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' })
                e.style.display = 'none'
            }
        }
    })
})

// Klaviyo trigger
document.querySelectorAll('[data-klaviyo]').forEach(e=> {
  e.addEventListener('click', function(evt) {
    evt.preventDefault()

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', e.dataset.klaviyo]);
  })
})

function tagContentCtaLink(link, attributes) {
  if (!link || link.hasAttribute('data-content-cta')) return;

  link.setAttribute('data-content-cta', '');
  Object.entries(attributes).forEach(function([name, value]) {
    link.setAttribute(name, value);
  });
}

function tagContentCtaLinks() {
  if (window.location.pathname === '/pages/home-assistant') {
    document
      .querySelectorAll('a[href="/pages/replace-old-alarm-panel-or-keep-it"]')
      .forEach(function(link) {
        tagContentCtaLink(link, {
          'data-content-slug': 'home-assistant',
          'data-content-cluster': 'alarm_panel',
          'data-destination-type': 'guide',
          'data-cta-location': 'intro_text',
        });
      });
  }

  [
    {
      path: '/collections/smart-alarm-panels',
      contentSlug: 'alarm_panel_collection',
      ctaLocation: 'alarm_collection_post_publish',
    },
    {
      path: '/products/konnected-alarm-panel-pro-12-zone-kit',
      contentSlug: 'alarm_panel_pro_conversion',
      ctaLocation: 'product_page_post_publish',
    },
    {
      path: '/products/konnected-alarm-panel-pro-12-zone-interface-kit',
      contentSlug: 'alarm_panel_pro_interface',
      ctaLocation: 'product_page_post_publish',
    },
    {
      path: '/pages/home-assistant',
      contentSlug: 'home-assistant',
      ctaLocation: 'alarm_section_post_publish',
    },
  ]
    .filter(function(route) {
      return window.location.pathname === route.path;
    })
    .forEach(function(route) {
      [
        '/pages/reuse-old-wired-alarm-sensors-smart-home',
        '/pages/smart-home-security-system-no-monthly-fee',
      ].forEach(function(destinationPath) {
        document.querySelectorAll(`a[href="${destinationPath}"]`).forEach(function(link) {
          tagContentCtaLink(link, {
            'data-content-slug': route.contentSlug,
            'data-content-cluster': 'alarm_panel',
            'data-destination-type': 'guide',
            'data-cta-location': route.ctaLocation,
          });
        });
      });
    });

  [
    {
      path: '/',
      contentSlug: 'home',
      contentCluster: 'platform_integrations',
      ctaLocation: 'platform_logo_row',
    },
    {
      path: '/collections/smart-garage-door-openers',
      contentSlug: 'gdo_collection',
      contentCluster: 'garage_gdo',
      ctaLocation: 'platform_logo_row',
    },
    {
      path: '/products/smart-garage-door-opener',
      contentSlug: 'gdo_white',
      contentCluster: 'garage_gdo',
      ctaLocation: 'platform_logo_row',
    },
    {
      path: '/collections/smart-alarm-panels',
      contentSlug: 'alarm_panel_collection',
      contentCluster: 'alarm_panel',
      ctaLocation: 'platform_logo_row',
    },
    {
      path: '/pages/platforms',
      contentSlug: 'platforms',
      contentCluster: 'platform_integrations',
      ctaLocation: 'platform_card',
    },
  ]
    .filter(function(route) {
      return window.location.pathname === route.path;
    })
    .forEach(function(route) {
      document.querySelectorAll('a[href="/pages/alexa"]').forEach(function(link) {
        tagContentCtaLink(link, {
          'data-content-slug': route.contentSlug,
          'data-content-cluster': route.contentCluster,
          'data-destination-type': 'integration_page',
          'data-cta-location': route.ctaLocation,
        });
      });
    });

  [
    {
      path: '/pages/alexa',
      contentSlug: 'alexa',
      contentCluster: 'garage_gdo',
      destinationPath: '/pages/amazon-alexa-automation-ideas-konnected',
      ctaLocation: 'integration_page_post_publish',
    },
    {
      path: '/collections/smart-garage-door-openers',
      contentSlug: 'gdo_collection',
      contentCluster: 'garage_gdo',
      destinationPath: '/pages/amazon-alexa-automation-ideas-konnected',
      ctaLocation: 'collection_intro',
    },
    {
      path: '/collections/smart-garage-door-openers',
      contentSlug: 'gdo_collection',
      contentCluster: 'garage_gdo',
      destinationPath: '/pages/josh-ai-garage-door-automation-ideas',
      ctaLocation: 'collection_intro',
    },
    {
      path: '/products/smart-garage-door-opener',
      contentSlug: 'gdo_white',
      contentCluster: 'garage_gdo',
      destinationPath: '/pages/amazon-alexa-automation-ideas-konnected',
      ctaLocation: 'platform_faq',
    },
    {
      path: '/products/smart-garage-door-opener-blaq-myq-alternative',
      contentSlug: 'gdo_blaq',
      contentCluster: 'garage_gdo',
      destinationPath: '/pages/amazon-alexa-automation-ideas-konnected',
      ctaLocation: 'platform_faq',
    },
    {
      path: '/products/smart-garage-door-opener-blaq-myq-alternative',
      contentSlug: 'gdo_blaq',
      contentCluster: 'garage_gdo',
      destinationPath: '/pages/josh-ai-garage-door-automation-ideas',
      ctaLocation: 'platform_faq',
    },
    {
      path: '/pages/joshai',
      contentSlug: 'joshai',
      contentCluster: 'garage_gdo',
      destinationPath: '/pages/josh-ai-garage-door-automation-ideas',
      ctaLocation: 'integration_page_post_publish',
    },
  ]
    .filter(function(route) {
      return window.location.pathname === route.path;
    })
    .forEach(function(route) {
      document.querySelectorAll(`a[href="${route.destinationPath}"]`).forEach(function(link) {
        tagContentCtaLink(link, {
          'data-content-slug': route.contentSlug,
          'data-content-cluster': route.contentCluster,
          'data-destination-type': 'guide',
          'data-cta-location': route.ctaLocation,
        });
      });
    });

  // Links inside template content. Shopify rejects data-* attributes in rich text
  // settings, and custom liquid uses the same table for consistency. Each rule is
  // scoped to one section (and, by default, the rich text copy within it) so cards
  // and menu links to the same URL aren't tagged too. Set `within: null` to match
  // anywhere in the section, e.g. custom liquid markup.
  [
    {
      path: '/collections/smart-alarm-panels',
      section: 'grid_section_AfzNBp',
      contentSlug: 'alarm_panel_collection',
      contentCluster: 'alarm_panel',
      ctaLocation: 'tablet_decision_copy',
      links: [{ href: '/pages/usb-c-pd-vs-12v-to-5v-usb-power-converter', destinationType: 'guide' }],
    },
    {
      path: '/collections/smart-garage-door-openers',
      section: 'section_gdo_buying_guides',
      contentSlug: 'smart-garage-door-openers',
      contentCluster: 'garage_gdo',
      ctaLocation: 'gdo_decision_accordion',
      links: [
        { href: '/pages/myq-home-assistant-alternative', destinationType: 'guide' },
        { href: '/pages/ratgdo-vs-konnected-gdo-blaq', destinationType: 'guide' },
        { href: '/products/smart-garage-door-opener-blaq-myq-alternative', destinationType: 'product' },
        { href: '/products/konnected-smart-garage-door-opener', destinationType: 'product' },
      ],
    },
    {
      path: '/products/smart-garage-door-opener-blaq-myq-alternative',
      section: 'section_TAQrRD',
      contentSlug: 'gdo-blaq',
      contentCluster: 'garage_gdo',
      ctaLocation: 'product_faq',
      links: [{ href: '/pages/ratgdo-vs-konnected-gdo-blaq', destinationType: 'guide' }],
    },
    {
      path: '/products/smart-garage-door-opener-blaq-myq-alternative',
      section: 'section_myq_home_assistant_answer',
      contentSlug: 'gdo-blaq',
      contentCluster: 'garage_gdo',
      ctaLocation: 'myq_home_assistant_answer',
      links: [
        { href: '/pages/myq-home-assistant-alternative', destinationType: 'guide' },
        { href: '/collections/smart-garage-door-openers', destinationType: 'collection' },
      ],
    },
    {
      path: '/products/konnected-alarm-panel-pro-12-zone-kit',
      section: 'section_FKBXbw',
      contentSlug: 'alarm_panel_pro_conversion',
      contentCluster: 'alarm_panel',
      ctaLocation: 'tablet_power_section',
      links: [{ href: '/pages/usb-c-pd-vs-12v-to-5v-usb-power-converter', destinationType: 'guide' }],
    },
    {
      path: '/pages/joshai',
      section: 'section_joshai_compatibility',
      within: null,
      contentSlug: 'joshai',
      contentCluster: 'garage_gdo',
      ctaLocation: 'compatibility_table',
      links: [
        { href: 'https://konnected.io/products/smart-garage-door-opener-blaq-myq-alternative', destinationType: 'product' },
        { href: 'https://konnected.io/products/smart-garage-door-opener', destinationType: 'product' },
        { href: 'https://konnected.io/collections/smart-garage-door-openers', destinationType: 'collection' },
      ],
    },
    {
      path: '/pages/joshai',
      section: 'josh_ai_shop_products',
      within: null,
      contentSlug: 'joshai',
      contentCluster: 'garage_gdo',
      ctaLocation: 'product_card',
      links: [
        { href: 'https://konnected.io/products/smart-garage-door-opener-blaq-myq-alternative', destinationType: 'product' },
        { href: 'https://konnected.io/products/smart-garage-door-opener', destinationType: 'product' },
      ],
    },
    {
      path: '/pages/joshai',
      section: 'josh_ai_shop_products',
      within: null,
      contentSlug: 'joshai',
      contentCluster: 'garage_gdo',
      ctaLocation: 'related_resources',
      links: [
        {
          href: 'https://community.konnected.io/t/konnected-josh-ai-the-ultimate-privacy-first-smart-garage-experience/40252',
          destinationType: 'support_page',
        },
        { href: 'https://www.josh.ai/devices', destinationType: 'other' },
        { href: 'https://konnected.io/collections/smart-garage-door-openers', destinationType: 'collection' },
      ],
    },
  ]
    .filter(function(route) {
      return window.location.pathname === route.path;
    })
    .forEach(function(route) {
      const within = route.within === undefined ? ':is(.text-block, .details-content) ' : route.within ? `${route.within} ` : '';

      document.querySelectorAll(`[id$="__${route.section}"]`).forEach(function(section) {
        route.links.forEach(function(destination) {
          section.querySelectorAll(`${within}a[href="${destination.href}"]`).forEach(function(link) {
            tagContentCtaLink(link, {
              'data-content-slug': route.contentSlug,
              'data-content-cluster': route.contentCluster,
              'data-destination-type': destination.destinationType,
              'data-cta-location': route.ctaLocation,
            });
          });
        });
      });
    });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', tagContentCtaLinks);
} else {
  tagContentCtaLinks();
}

document.addEventListener('click', function(event) {
  const link = event.target.closest('a[data-content-cta]');
  if (!link || typeof window.gtag !== 'function') return;

  const destinationUrl = link.href || link.getAttribute('href') || '';
  const destinationPath = [link.pathname, link.search, link.hash].join('');
  const contentSlug = link.dataset.contentSlug || '';
  const destinationType = link.dataset.destinationType || 'other';
  const ctaLocation = link.dataset.ctaLocation || 'other';
  const imageLabel = link.querySelector('img[alt]')?.getAttribute('alt') || '';
  const ctaLabel = (link.textContent.trim() || link.getAttribute('aria-label') || imageLabel || link.title || '').slice(0, 100);

  window.gtag('event', 'content_cta_click', {
    content_url: window.location.pathname,
    content_slug: contentSlug,
    content_cluster: link.dataset.contentCluster || '',
    destination_url: destinationUrl,
    destination_type: destinationType,
    cta_label: ctaLabel,
    cta_location: ctaLocation,
    event_category: 'content_cta',
    event_label: [contentSlug, destinationType, ctaLocation, destinationPath || destinationUrl].join('|').slice(0, 100),
  });
});

// ============================================================
// 2026 visual refresh: hero quote rotator + reveal-on-scroll
// Companion styles live in custom.css (.k-quote, .k-willreveal).
// ============================================================

function initQuoteRotators() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.querySelectorAll('.k-quote-rotator').forEach((rotator) => {
    const quotes = rotator.querySelectorAll('.k-quote');
    if (quotes.length < 2) return;

    let index = Math.max(0, [...quotes].findIndex((q) => q.classList.contains('is-active')));
    setInterval(() => {
      quotes[index].classList.remove('is-active');
      index = (index + 1) % quotes.length;
      quotes[index].classList.add('is-active');
    }, 5000);
  });
}

function initRevealOnScroll() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  const targets = [...document.querySelectorAll('.k-reveal')].filter(
    // Only animate elements that start below the fold; anything already
    // visible on load stays put (no flash, no CLS).
    (el) => el.getBoundingClientRect().top > window.innerHeight
  );
  if (!targets.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('k-inview');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.2 }
  );

  targets.forEach((el) => {
    el.classList.add('k-willreveal');
    observer.observe(el);
  });
}

// The stock marquee clones its items to fill the row and marks only the
// outer clone aria-hidden, leaving duplicate logo links in the tab order.
// Make every copy after the first set inert (unfocusable, hidden from AT).
function initLogoMarquees() {
  document.querySelectorAll("[id$='__logo_marquee'] marquee-component").forEach((marquee) => {
    const hideCopies = () => {
      marquee.querySelectorAll('.marquee__repeated-items').forEach((items, index) => {
        if (index > 0) items.inert = true;
      });
      marquee.querySelectorAll('.marquee__content[aria-hidden]').forEach((clone) => {
        clone.inert = true;
      });
    };

    hideCopies();
    new MutationObserver(hideCopies).observe(marquee, { childList: true, subtree: true });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initQuoteRotators();
    initRevealOnScroll();
    initLogoMarquees();
  });
} else {
  initQuoteRotators();
  initRevealOnScroll();
  initLogoMarquees();
}
